import { useEffect, useState } from "react";
import { makeRequest } from "../makeRequest";

// Light populate: only what AddressCard / Checkout / AddressBook actually read
export const buildAddressesUrl = (userId, retries = 0) => {
    if (!userId) return null;
    const p = new URLSearchParams();
    p.set("filters[User][id][$eq]", userId);
    p.set("sort", "updatedAt:desc");
    ["Country", "City", "Area"].forEach((rel) => {
        p.set(`populate[${rel}][fields][0]`, "Name");
        p.set(`populate[${rel}][populate][localizations][fields][0]`, "Name");
        p.set(`populate[${rel}][populate][localizations][fields][1]`, "locale");
    });
    p.set("populate[User][fields][0]", "username"); // AddressCard needs User.data.id
    if (retries > 0) p.set("_retry", retries);
    return `/addresses?${p.toString()}`;
};

const wait = (ms, signal) =>
    new Promise((resolve) => {
        const id = setTimeout(resolve, ms);
        signal?.addEventListener("abort", () => { clearTimeout(id); resolve(); }, { once: true });
    });

// Same return shape as useFetch, plus timeout and automatic retry
export const useAddressesFetch = (
    url,
    // { timeout = 12000, retries = 2, retryDelay = 800 } = {}
    { timeout = 8000, retries = 1, retryDelay = 500 } = {}
) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!url) return;
        const controller = new AbortController();
        let active = true;

        const run = async () => {
            setLoading(true);
            setData(null);
            setError(false);
            for (let attempt = 0; attempt <= retries; attempt++) {
                try {
                    //   const res = await makeRequest.get(url, { signal: controller.signal, timeout });
                    const res = await makeRequest.get(url, {
                        signal: controller.signal,
                        timeout,
                        params: { _t: Date.now() },
                    });
                    if (!active) return;
                    setData(res.data.data);
                    setLoading(false);
                    return;
                } catch (err) {
                    if (!active || controller.signal.aborted) return;
                    if (attempt === retries) {
                        setError(true);
                        setLoading(false);
                        return;
                    }
                    await wait(retryDelay * (attempt + 1), controller.signal);
                    if (!active) return;
                }
            }
        };
        run();

        return () => { active = false; controller.abort(); };
    }, [url]);

    return { data, loading, error };
};